import {
  getGiftPaymentStatus,
  getPaymentStatus,
} from '@ieo/Components/Form/ieo/api/registrationFormApi';

/*
Data from user auth API:
{
    "fname": "Alex",
    "lname": "Makkaveyev",
    "address1": "951 Isha Lanefdsfda ",
    "address2": "",
    "city": "McMinnville",
    "state": "Andhra Pradesh",
    "zip": "37110",
    "country": "IN",
    "pPhone": "8608666909",
    "sPhone": "8608666909",
    "email": "alex.m+0987@ishausa.org",
    "id": "30392",
    "txnId": "IEO-1694829759-14346",
    "item": "New",
    "tCost": 4000,
    "pmtCurr": "INR",
    "regDate": "2023-09-15 22:02:38",
    "status": "A",
    "resetUrl": "<JSON>"
}
 */

export async function authenticateUser(data) {
  const start = Date.now();
  let delay = 1000;

  const makeApiRequest = async () => {
    // const res = await Axios.post(getApiUrl() + apiEndpoint, data);
    let res = {};
    if (data.isGiftingFlow) {
      res = await getGiftPaymentStatus(data);
      // delete data.isGiftingFlow;
    } else {
      res = await getPaymentStatus(data);
    }

    // If the request takes more than 5 minutes, stop trying
    if (Date.now() - start > 5 * 60 * 1000) {
      return null;
    }

    // Keep making requests until the status is not InProgress
    if (res?.status === 'InProgress') {
      return new Promise(resolve => {
        setTimeout(() => {
          delay += 1000;
          resolve(makeApiRequest());
        }, delay);
      });
    } else {
      if (res?.message) {
        return res;
      }
      return res || res.error;
    }
  };

  return makeApiRequest();
}
